import Logger from "@cappelendamm/logger";
import { deleteApp } from "../mutations/deleteApp.pim.js";
import { getAllApps } from "../queries/getAllApps.pim.js";
import { createApp } from "../mutations/createApp.pim.js";
const APPS_URL_UTV_ROUTING = [
    {
        name: "Customer service",
        identifier: "prod-customer-service",
        url: "https://utv-customer-service.vercel.app",
    },
    {
        name: "Localhost customer service",
        identifier: "localhost-test",
        url: "https://localhost:3001/",
    },
    {
        name: "Subscriptions",
        identifier: "subscriptions",
        url: "https://subscription-contract.app-labs.crystallize.com",
    },
];
const UTV_TENANT_ID = process.env.UTV_TENANT_ID;
export const setAppsToEnvUrls = async (client, tenantToUpdate) => {
    let tenantId;
    let appRoutes;
    if (tenantToUpdate === "cada-netthandel-utv") {
        tenantId = UTV_TENANT_ID;
        appRoutes = APPS_URL_UTV_ROUTING;
    }
    if (!tenantId || !appRoutes) {
        return {
            success: false,
            message: `No tenantId or appRoutes found for ${tenantToUpdate}`,
        };
    }
    //Delete all production copied production apps
    const allAppsInTenant = await getAllApps({ tenantId }, { client });
    if (allAppsInTenant) {
        Logger.log(`Deleting all apps in: ${tenantId}...`);
        let deletedApps = 0;
        for (const app of allAppsInTenant) {
            const id = await deleteApp({ tenantId, identifier: app.identifier }, { client });
            deletedApps++;
        }
        Logger.log(`Deleted ${deletedApps}/${allAppsInTenant.length} apps in ${tenantId}...`);
    }
    //Create environment specific apps
    let createdApps = 0;
    for (const appRoute of appRoutes) {
        const id = await createApp({
            input: {
                tenantId: tenantId,
                name: appRoute.name,
                identifier: appRoute.identifier,
                baseUrl: appRoute.url,
            },
        }, { client });
        if (id)
            createdApps++;
    }
    if (createdApps == appRoutes.length) {
        return {
            success: true,
            message: `${createdApps} apps created in ${tenantId}`,
        };
    }
    else {
        return {
            success: false,
            message: `Only ${createdApps} apps created in ${tenantId}`,
        };
    }
};
